import { combineReducers } from 'redux';
import clusterRolesReducer from './clusterRoles/clusterRoles.reducer';

export default combineReducers({
  clusterRoles: clusterRolesReducer
});
